"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarContent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var enums_1 = require("../../enums");
var Avatar_1 = require("../Avatar");
var AvatarContent = function (_a) {
    var className = _a.className, type = _a.type, avatarProps = _a.avatarProps, children = _a.children, props = __rest(_a, ["className", "type", "avatarProps", "children"]);
    var cls = (0, BootstrapHelper_1.B)().bl("avatar-content");
    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, props, { className: "".concat(className || "", " ").concat(cls.pmod(type || "primary").bem) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("block").pmod("avatar-wrapper").bem) }, { children: (0, jsx_runtime_1.jsx)(Avatar_1.Avatar, __assign({ size: avatarProps.size || enums_1.UiSizes.SM, borderType: "border-primary", className: "".concat(avatarProps.className || "", " ").concat(cls.el("avatar").bem) }, avatarProps)) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("block").pmod("content").bem) }, { children: children }))] })));
};
exports.AvatarContent = AvatarContent;
